export default __webpack_public_path__ + "static/media/hyperledgerfabric2.9916ee25.jpeg";